import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

type AlertVariant = "default" | "destructive" | "info" | "success";

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
}

const variants: Record<AlertVariant, string> = {
  default:     "border-zinc-300 bg-zinc-50 text-brand-black",
  destructive: "border-danger bg-red-50 text-danger",
  info:        "border-info bg-sky-50 text-info",
  success:     "border-emerald-500 bg-emerald-50 text-emerald-900"
};

export const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  { className, variant = "default", role = "alert", ...props },
  ref
) {
  return (
    <div
      ref={ref}
      role={role}
      className={cn("rounded-md border px-3 py-2 text-sm", variants[variant], className)}
      {...props}
    />
  );
});
